var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('checkout',{attrs:{"trans":_vm.trans_checkout,"lang":_vm.lang,"redirect":_vm.redirect,"free":_vm.free}}):_c('login-component',{attrs:{"trans":_vm.trans_auth,"lang":_vm.lang,"redirect":"checkout","showLoader":_vm.showLoader}})
}
var staticRenderFns = []

export { render, staticRenderFns }